import _classCallCheck from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classPrivateFieldInitSpec from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldGet from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { Storage } from "@services/storage";
var _storage = /*#__PURE__*/new WeakMap();
export var AccountStorage = /*#__PURE__*/function () {
  function AccountStorage() {
    _classCallCheck(this, AccountStorage);
    _classPrivateFieldInitSpec(this, _storage, new Storage({
      namespace: "account"
    }));
  }
  return _createClass(AccountStorage, [{
    key: "getCacheUserInfo",
    value: function getCacheUserInfo() {
      return _classPrivateFieldGet(_storage, this).get("userInfo");
    }
  }, {
    key: "setCacheUserInfo",
    value: function setCacheUserInfo() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _classPrivateFieldGet(_storage, this).set("userInfo", data);
    }
  }, {
    key: "removeCacheUserInfo",
    value: function removeCacheUserInfo() {
      return _classPrivateFieldGet(_storage, this).remove("userInfo");
    }
  }, {
    key: "getCacheUserList",
    value: function getCacheUserList() {
      return _classPrivateFieldGet(_storage, this).get("userList");
    }
  }, {
    key: "setCacheUserList",
    value: function setCacheUserList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _classPrivateFieldGet(_storage, this).set("userList", data);
    }
  }, {
    key: "removeCacheUserList",
    value: function removeCacheUserList() {
      return _classPrivateFieldGet(_storage, this).remove("userList");
    }
  }, {
    key: "getCacheAccessToken",
    value: function getCacheAccessToken() {
      var userInfo = this.getCacheUserInfo();
      if (userInfo && userInfo.accessToken) {
        return userInfo.accessToken;
      }
      return;
    }
  }, {
    key: "getCacheAccountId",
    value: function getCacheAccountId(id) {
      var accountId = _classPrivateFieldGet(_storage, this).get("accountId");
      if (accountId) {
        return accountId[id];
      }
      return;
    }
  }, {
    key: "setCacheAccountId",
    value: function setCacheAccountId(id, vcode, pwd) {
      pwd || (pwd = "");
      var data = {};
      data[id] = {
        id: id,
        pwd: pwd,
        vcode: vcode
      };
      return _classPrivateFieldGet(_storage, this).set("accountId", data);
    }
  }, {
    key: "removeCacheAccountId",
    value: function removeCacheAccountId() {
      return _classPrivateFieldGet(_storage, this).remove("accountId");
    }
  }, {
    key: "getCacheLastAccountId",
    value: function getCacheLastAccountId() {
      return _classPrivateFieldGet(_storage, this).get("lastAccountId");
    }
  }, {
    key: "setCacheLastAccountId",
    value: function setCacheLastAccountId(id) {
      return _classPrivateFieldGet(_storage, this).set("lastAccountId", id);
    }
  }, {
    key: "removeCacheLastAccountId",
    value: function removeCacheLastAccountId() {
      return _classPrivateFieldGet(_storage, this).remove("lastAccountId");
    }
  }]);
}();